export default function Loader() {
  return <>Loading, please wait...</>;
}
